import { MessagingBannerVariant } from "./types";

/**
 * Maps a banner variant to its ARIA role.
 *
 * - `info` → `note` (static informational region).
 * - `warning` / `critical` → `alert` (assertive announcement).
 * - All other variants → `status` (polite announcement).
 */
export const getMessagingBannerRole = (
  variant: MessagingBannerVariant
): "note" | "alert" | "status" => {
  switch (variant) {
    case "info":
      return "note";
    case "warning":
    case "critical":
      return "alert";
    default:
      return "status";
  }
};
